import { createContext } from 'react'
import type { ArticleProfileApi } from './types'

/**
 * Контекст открытия профиля. Без провайдера (тесты страниц, изолированный рендер) значение `null`:
 * хук отдаёт пустой `open`, а кнопка профиля не рисуется — страница без провайдера работает как раньше.
 */
export const ArticleProfileContext = createContext<ArticleProfileApi | null>(null)
